import cacheApi from "app/lib/cacheApi";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const verifyCognitoAuth = async (params) => {
  const payload = Object.fromEntries(
    Object.entries(params).filter(([key, value]) => Boolean(value))
  );

  return await cacheApi.post(endpoints.cognito.verify, payload);
};

export const fetchAuthUrl = async (targetApp) => {
  const provider = targetApp.toLowerCase();
  const url = interpolate(endpoints.cognito.authUrl, { provider });

  return await cacheApi.get(url);
};
